export default __webpack_public_path__ + "static/media/627.bfb041e4.jpg";